import React from 'react'
import { useRef } from 'react'
import emailjs from '@emailjs/browser';

const Contact = () => {
    const form = useRef()

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
          .sendForm('service_383oflg', 'template_wdv3fyp', form.current, {
            publicKey: 'xxMVIQ_gv4oZMWvvj',
          })
          .then(
            () => {
              console.log('SUCCESS!');
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
          e.target.reset();
      };
    
  return (
    <div className='max-w-[100%] mx-auto sm:py-20 p-5 mt-10 mb-10' id='contact'>

        <div className='text-center'>
            <h1 className=' text-4xl font-bold leading-tight primary-color'>Contact Me</h1>
            </div>
            <div className='max-w-[800px] mx-auto'>

                <div class="mt-6 bg-[#161616] rounded-xl">
                    <div class="p-10">
                        <form ref={form} onSubmit={sendEmail}>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
                            <div>
                                <div class="mt-2.5 ">
                                    <input type='text' name='user_name'  placeholder='Your Name'
                                    className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border
                                    border-gray-700 rounded-md focus:outline-none focus:border-pink-600'/>
                                </div>
                            </div>

                            <div>
                                <div class="mt-2.5 ">
                                    <input type='text' name='user_email'  placeholder='Your Email'
                                    className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border
                                    border-gray-700 rounded-md focus:outline-none focus:border-pink-600'/>
                                </div>
                            </div>

                            <div class="sm:col-span-2">
                                <div class="mt-2.5 ">
                                    <textarea name='message' placeholder='Your Message'
                                    className='bg-[#161616] w-full px-4 py-4 text-gray-400 placeholder-gray-400 border border-gray-700
                                    rounded-md focus:outline-none focus:border-pink-600' rows="4"></textarea>
                                </div>
                            </div>


                            <div class="sm:col-span-2">
                                <button type = "submit" 
                                class = "text-xl w-full p-4 mt-2 font-semibold text-white bg-primary-color rounded-md">
                                    Send
                                </button>
                            </div>
                            </div>
                        </form>

                 
                </div>
            </div>
        </div>
    
    </div>
  )
}

export default Contact
